module.exports = {
	"articleTitle1": "Aut and proud",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Aut Bar",
	"articleLink1": "https://www.michigandaily.com/arts/10secondary-aut-bar-10",
	"articleLink2": "https://www.michigandaily.com/section/statement/girl-walks-bar-braun-court",
	"articleSnippet1": "Oct 10, 2013 ... Aut Bar provides a place of safety for the LGBTQIA community — a piece of \ncommon ground over light brunch, beer or laugh at the bar.",
	"articleSnippet2": "Mar 7, 2017 ... Like any good story, my column starts when a girl walks into a bar. ... of the bar \noverlooking the courtyard, where the view of Aut Bar's neon-lit ...",
	"foodRecommendations": [
		{
			"text": "Pretty standard breakfast. They have deletable huevos rancheros.",
			"person": "Ben Iaderosa"
		}
	],
	"articleTitle2": "A Girl Walks Into: Bar on Braun Court ",
	"address": "315 Braun Ct, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/nwi.bside_.autbar.10.9.135.jpg",
			"author": "Nicholas Williams",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.283782,
		"lng": -83.747423
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/autbar.json
// module id = 817
// module chunks = 0